import ListItem from "@mui/material/ListItem";
import IconButton from "@mui/material/IconButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import DeleteIcon from "@mui/icons-material/Delete";
import React, { useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import * as api from "./api";
import { Collapse, Divider, Stack, Typography } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import FileDownloadDoneIcon from "@mui/icons-material/FileDownloadDone";
import { useErrorMessage } from "@poseidon/ui/app/toasts/useErrorMessage";
import { useToastMessage } from "@poseidon/ui/app/toasts/useToastMessage";
import { formatBytes } from "@poseidon/utils/formatBytes";
import { Box } from "@mui/material";
import { ChipSmall } from "../ChipSmall";
import { getDate } from "@poseidon/firebase/timestamp";

export default function FileListItem({
  file,
  resolveMetadata,
  showFileMetadata,
  readonly,
}) {
  const { setError } = useErrorMessage();
  const { setToast } = useToastMessage();
  const [loading, setLoading] = useState(false);
  const [downloaded, setDownloaded] = useState(false);

  const deleteFile = async (file) => {
    setLoading(true);
    const response = await api.removeFile(file);

    if (response instanceof Error) {
      setError(response.message);
      return setLoading(false);
    }

    setToast(response);
    setLoading(false);
  };

  const downloadFile = async (file) => {
    setLoading(true);
    const response = await api.downloadFile(file.uploadPath);

    if (response instanceof Error) {
      setError(response.message);
      return setLoading(false);
    }

    setToast(response);
    setLoading(false);
    setDownloaded(true);
  };

  return (
    file && (
      <>
        <ListItem
          secondaryAction={
            readonly ? undefined : (
              <IconButton
                edge="end"
                aria-label="delete"
                onClick={() => deleteFile(file)}
              >
                {loading ? <CircularProgress size={28} /> : <DeleteIcon />}
              </IconButton>
            )
          }
        >
          <ListItemIcon>
            <IconButton
              edge="end"
              aria-label="download"
              onClick={() => downloadFile(file)}
            >
              {downloaded ? (
                <FileDownloadDoneIcon size={28} />
              ) : (
                <FileDownloadIcon />
              )}
            </IconButton>
          </ListItemIcon>
          <Stack>
            <ListItemText
              primary={
                <>
                  {file.name} {" | "}
                  <Typography
                    sx={{ display: "inline" }}
                    component="span"
                    variant="body2"
                    color="text.secondary"
                  >
                    {getDate(file?.createdAt)?.toLocaleDateString("en-GB")}
                  </Typography>
                </>
              }
            />
            <Collapse in={showFileMetadata} timeout="auto" unmountOnExit>
              <Box mb={1}>
                {file.size && <ChipSmall>{formatBytes(file.size)}</ChipSmall>}
                {file.filePurpose && (
                  <ChipSmall>
                    {resolveMetadata?.getLabel(file.filePurpose) ||
                      file.filePurpose}
                  </ChipSmall>
                )}
              </Box>
            </Collapse>
          </Stack>
        </ListItem>
        <Divider variant="inset" component="li" />
      </>
    )
  );
}
